module.exports = __webpack_public_path__ + "static/media/slide-or-short.67eca288.svg";